<script>
  import { onMount } from 'svelte'
  import { fade, fly } from 'svelte/transition'
  import Menu from './components/Menu.svelte'
  import Loader from './themes/PlayFair/Loader.svelte'
  import Editor from './components/Editor.svelte'
  import Blocks from './components/Blocks.svelte'


  let btnCaption = '<i class="fa fa-user"></i> Login / Register'

  let blocksConfig = {}
  blocksConfig.categories = []
  blocksConfig.blocks = []

  let data = {}

  data.title = 'My Website'
  data.description = ''
  data.url = ''
  data.entries = []
  data.design = {
    color: '#000',
    color2: '#FFF',
    font: 'PlayfairDisplay-Muli',
  }
  data.base = 'https://sitefiction-svelte.now.sh/'

  onMount(async () => {

    if (localStorage.getItem('json') != null) {
      let json = JSON.parse(localStorage.getItem('json'))
      console.log(json)
      data = json

      let root = document.documentElement
      root.style.setProperty('--primary-color', data.design.color)
      root.style.setProperty('--secondary-color', data.design.color2)
      if (data.design.font !== 'PlayfairDisplay-Muli') {
        document.querySelector('#font').href =
          'fonts/' + data.design.font + '.css'
      }
    }

  })

  let currentId = 0
  let showEdit = false
  let showPublish = false
  let showLogin = false
  let loggedIn = false
  let user = ''
  let editMode = true

  function hideEdit() {
    showEdit = false
  }



  function download(){

    let html = document.querySelector('#main').innerHTML
    let json = JSON.stringify(data)

    localStorage.setItem('html', html)
    localStorage.setItem('json', json)

    var url = "https://gumroad.com/l/sitefiction-download/?template=123";
    var win = window.open(url, '_blank');
    win.focus();

  }
</script>

<nav>
  <img src="assets/img/title.png" id="title" alt="title" />

<button class="btn btn-outline-dark float-right" id="download" on:click="{download}">Download</button>

</nav>

<div class="row no-gutters" id="wrap">

  <div class="col-md-2" id="side">
    <Menu bind:data bind:blocksConfig bind:showEdit bind:user />
  </div>

  <div class="col-md-10" id="main">
    <Loader
      bind:data
      bind:currentId
      bind:showEdit
      bind:blocksConfig
      bind:editMode />
  </div>

</div>

{#if showEdit}
  <div
    id="edit"
    in:fly={{ x: 300, duration: 500 }}
    out:fly={{ x: 300, duration: 500 }}>
    {#if currentId != 0}
      <Editor bind:data bind:currentId bind:showEdit bind:loggedIn bind:user />
    {/if}
  </div>
{/if}

<div id="blocks" style="display: none;">
  <Blocks bind:data bind:blocksConfig bind:loggedIn />
  <br />
  <br />
  <br />
</div>
